import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as RadixSelect from '@radix-ui/react-select';
import { forwardRef } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../../const/colors/staticColors';
import { useGetTestIdAttribute } from '../../../hooks/useTestIdAttribute';
import { HorizontalDivider } from '../../HorizontalDivider/HorizontalDivider';
import { Icon } from '../../Icon/Icon';
import { Text } from '../../Text/Text';
import { Box } from '../../layout/Box';
import { FlexContainer } from '../../layout/FlexContainer';
import { INPUT_TEXT_VARIANT } from '../useInputStyles';
const StyledItem = styled(RadixSelect.Item, ({ $isActive }) => ({
    cursor: 'pointer',
    userSelect: 'none',
    backgroundColor: $isActive
        ? staticColors.selectItemActiveBackgroundColor
        : undefined,
    ':hover': {
        backgroundColor: staticColors.selectItemActiveBackgroundColor,
    },
    ':focus-visible': {
        outline: 'none',
        backgroundColor: staticColors.selectItemActiveBackgroundColor,
    },
}));
const StyledIndicator = styled(RadixSelect.ItemIndicator, {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
});
export const SelectItem = forwardRef(({ testId, isActive, ...props }, ref) => {
    const getTestIdAttribute = useGetTestIdAttribute();
    const testIdAttribute = getTestIdAttribute(testId);
    return (_jsx(StyledItem, { ...props, ...testIdAttribute, ref: ref, $isActive: isActive }));
});
SelectItem.displayName = 'SelectItem';
export const SelectItemContent = ({ text, withDivider, withIndicator = false, }) => {
    const maybeIndicator = withIndicator && (_jsx(StyledIndicator, { children: _jsx(Icon, { name: 'Check', color: 'grey' }) }));
    return (_jsxs(Box, { spacingHorizontal: true, spacingTop: true, children: [_jsxs(FlexContainer, { direction: 'row', verticalAlign: 'center', horizontalAlign: 'spaceBetween', children: [_jsx(RadixSelect.ItemText, { children: _jsx(Text, { variant: INPUT_TEXT_VARIANT, align: 'start', overflow: 'hidden', textOverflow: 'ellipsis', children: text }) }), maybeIndicator] }), _jsx(Box, { spacingTop: true }), withDivider && _jsx(HorizontalDivider, {})] }));
};
